import React, { Component } from 'react';
import { Row, Col, Table, Card } from 'react-bootstrap';
import moment from 'moment';
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';

const fmtDate = (unix) => unix ? moment.unix(parseInt(unix)).format("DD MMM YYYY") : "—";
const rupeeFmt = (v) => `₹${(v || 0).toLocaleString("en-IN")}`;

// Helper to estimate term text from term number
const getTermRangeText = (termNo) => {
    switch (termNo) {
        case 1: return "Apr–Jun 25";
        case 2: return "Jul–Sep 25";
        case 3: return "Oct–Dec 25";
        case 4: return "Jan–Mar 26";
        case 5: return "Apr–Jun 26";
        default: return `Term ${termNo}`;
    }
};

class StudentFees extends Component {
    constructor(props) {
        super(props);
    }

    viewPDF = (payment) => {
        const { student, getOrganisationProfile } = this.props;
        const studentName = student?.student_name || "—";
        const classNameStr = student?.class_name || "—";
        const admissionNoStr = student?.admission_no || "—";
        const orgName = getOrganisationProfile?.organisation_name || "Rizee College";
        const logoFile = getOrganisationProfile?.logo || "";
        const address = getOrganisationProfile?.complete_address || student?.branch_name || "College Branch Office";
        const logoDataUrl = logoFile ? `https://support.rizee.in/files/${logoFile}` : "";
        const academicYear = "2026-27";
        const classAdm = [classNameStr, admissionNoStr].filter(Boolean).join(" / Adm No: ");
        const receiptDate = payment.paid_date ? moment.unix(parseInt(payment.paid_date)).format("DD/MMM/YYYY") : "—";
        const amountPaidFormatted = (payment.amount || 0).toLocaleString("en-IN");

        const dataRows = [
            ["Academic Year", academicYear],
            ["Student Name", studentName],
            ["Class / Adm No", classAdm],
            ["Fee Type", `${payment.fee_type || payment.description} – Term ${payment.term_no}`],
            ["Total Paid", `&#x20B9;${amountPaidFormatted} (${payment.payment_mode || '—'})`],
        ];

        const rowsHtml = dataRows.map(([label, value]) => `
                <tr>
                    <td style="padding:6px 0;font-size:13px;color:#555;width:220px">${label}</td>
                    <td style="padding:6px 0;font-size:13px;color:#555;width:20px;text-align:center">:</td>
                    <td style="padding:6px 0;font-size:13px;font-weight:700;color:#111">${value}</td>
                </tr>`).join("");

        const win = window.open("", "_blank", "width=800,height=700");
        win.document.write(`<html><head><title>Fee Receipt</title><style>
                *{margin:0;padding:0;box-sizing:border-box}
                body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
                .receipt-wrapper{width:700px;margin:0 auto;border:1.5px solid #333}
                .receipt-header{display:flex;align-items:center;gap:14px;padding:14px 18px 10px;border-bottom:1.5px solid #333}
                .hdr-logo{height:56px;width:auto;object-fit:contain;flex-shrink:0}
                .hdr-info{flex:1;text-align:center}
                .org-name{font-size:18px;font-weight:700;color:#111;margin-bottom:2px}
                .org-addr{font-size:11px;color:#555;line-height:1.5}
                .receipt-title{display:flex;align-items:center;padding:10px 18px;border-bottom:1.5px solid #333}
                .rt-side{flex:1;font-size:11px;font-weight:400;color:#333;line-height:1.5}
                .rt-main{font-size:16px;font-weight:700;text-align:center}
                .receipt-body{padding:14px 18px}
                .receipt-footer{border-top:1.5px solid #333;padding:10px 18px}
                @media print{html,body{height:auto!important}body{padding:2px}@page{size:auto;margin:3mm}}
            </style></head><body>
                <div class="receipt-wrapper">
                    <div class="receipt-header">
                        ${logoDataUrl ? `<img class="hdr-logo" src="${logoDataUrl}" />` : ""}
                        <div class="hdr-info">
                            <div class="org-name">${orgName}</div>
                            <div class="org-addr">${address}</div>
                        </div>
                    </div>
                    <div class="receipt-title">
                        <div class="rt-side" style="text-align:left">Receipt No: <strong>${payment.receipt_no || "—"}</strong><br/>Adm No: <strong>${admissionNoStr}</strong></div>
                        <div class="rt-main">Fee Receipt</div>
                        <div class="rt-side" style="text-align:right">Date: <strong>${receiptDate}</strong></div>
                    </div>
                    <div class="receipt-body">
                        <table style="width:100%;border-collapse:collapse">
                            <tbody>${rowsHtml}</tbody>
                        </table>
                    </div>
                    <div class="receipt-footer">
                        <div style="text-align:center;font-size:10px;color:#555;line-height:1.3">Note: Once a payment is made, it cannot be refunded. Thank You</div>
                        <div style="text-align:right;font-size:11px;font-weight:700;color:#333;margin-top:16px">School Stamp &amp; Sign</div>
                    </div>
                </div>
                <script>window.print();window.close();<\/script>
            </body></html>`);
        win.document.close();
        win.focus();
    };

    downloadAllPayments = (pList, totalPaidAmt) => {
        if (!pList || pList.length === 0) {
            window.alert("No payments found to download.");
            return;
        }
        const { student, getOrganisationProfile } = this.props;
        const studentName = student?.student_name || "—";
        const classNameStr = student?.class_name || "—";
        const rollNoStr = student?.roll_no || "—";
        const orgName = getOrganisationProfile?.organisation_name || "Rizee College";
        const logoFile = getOrganisationProfile?.logo || "";
        const address = getOrganisationProfile?.complete_address || student?.branch_name || "College Branch Office";
        const logoDataUrl = logoFile ? `https://support.rizee.in/files/${logoFile}` : "";
        const academicYear = "2026-27";
        const classAdm = [classNameStr, rollNoStr].filter(Boolean).join(" / Adm No: ");

        const sorted = [...pList].sort((a, b) => (parseInt(a.paid_date) || 0) - (parseInt(b.paid_date) || 0));

        const rowsHtml = sorted.map((p, idx) => {
            const term = `Term ${p.term_no}`;
            const date = p.paid_date ? moment.unix(parseInt(p.paid_date)).format("DD/MMM/YYYY") : "—";
            return `<tr>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb;text-align:center">${idx + 1}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.receipt_no || "—"}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.fee_type || "—"}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb">${term}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb">${date}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb">${p.payment_mode || "—"}</td>
                    <td style="padding:7px 10px;border:1px solid #e5e7eb;text-align:right;font-weight:700">&#x20B9;${(p.amount || 0).toLocaleString("en-IN")}</td>
                </tr>`;
        }).join("");

        const infoRows = [
            ["Academic Year", academicYear],
            ["Student Name", studentName],
            ["Class / Adm No", classAdm],
        ].map(([label, value]) => `
                <tr>
                    <td style="padding:4px 0;font-size:12px;color:#555;width:160px">${label}</td>
                    <td style="padding:4px 0;font-size:12px;color:#555;width:14px;text-align:center">:</td>
                    <td style="padding:4px 0;font-size:12px;font-weight:700;color:#111">${value}</td>
                </tr>`).join("");

        const win = window.open("", "_blank", "width=900,height=750");
        win.document.write(`<html><head><title>Payment History</title><style>
                *{margin:0;padding:0;box-sizing:border-box}
                body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
                .receipt-wrapper{width:800px;margin:0 auto;border:1.5px solid #333}
                .receipt-header{display:flex;align-items:flex-start;justify-content:space-between;padding:14px 18px 10px;border-bottom:1.5px solid #333}
                .hdr-left{display:flex;align-items:flex-start;gap:14px;flex:1}
                .hdr-left img{width:auto;height:60px;object-fit:contain;flex-shrink:0}
                .org-name{font-size:18px;font-weight:700;color:#111;margin-bottom:2px}
                .org-addr{font-size:11px;color:#555;line-height:1.5}
                .receipt-title{text-align:center;font-size:16px;font-weight:700;padding:10px 0;border-bottom:1.5px solid #333}
                .receipt-body{padding:14px 18px}
                .history-table{width:100%;border-collapse:collapse;margin-top:12px;font-size:12px}
                .history-table th{padding:8px 10px;border:1px solid #333;background:#f3f4f6;font-size:12px;text-align:left}
                .totals{margin-top:14px;display:flex;justify-content:flex-end;font-size:13px}
                .receipt-footer{border-top:1.5px solid #333;padding:10px 18px}
                @media print{html,body{height:auto!important}body{padding:2px}@page{size:auto;margin:5mm}}
            </style></head><body>
                <div class="receipt-wrapper">
                    <div class="receipt-header">
                        <div class="hdr-left">
                            ${logoDataUrl ? `<img src="${logoDataUrl}" />` : ""}
                            <div>
                                <div class="org-name">${orgName}</div>
                                <div class="org-addr">${address}</div>
                            </div>
                        </div>
                        <div style="text-align:right;font-size:10px;color:#333;min-width:160px;line-height:1.9">
                            <div>Date: <strong>${moment().format("DD/MMM/YYYY")}</strong></div>
                            <div>Total Receipts: <strong>${sorted.length}</strong></div>
                        </div>
                    </div>
                    <div class="receipt-title">Payment History</div>
                    <div class="receipt-body">
                        <table style="width:100%;border-collapse:collapse"><tbody>${infoRows}</tbody></table>
                        <table class="history-table">
                            <thead>
                                <tr>
                                    <th style="text-align:center;width:40px">#</th>
                                    <th>Receipt No</th>
                                    <th>Fee Type</th>
                                    <th>Term</th>
                                    <th>Paid Date</th>
                                    <th>Mode</th>
                                    <th style="text-align:right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>${rowsHtml}</tbody>
                        </table>
                        <div class="totals">
                            <div>Total Paid: <strong style="color:#15803d">&#x20B9;${(totalPaidAmt || 0).toLocaleString("en-IN")}</strong></div>
                        </div>
                    </div>
                    <div class="receipt-footer">
                        <div style="text-align:center;font-size:10px;color:#555;margin-bottom:2px">Note: Once a payment is made, it cannot be refunded.</div>
                        <div style="text-align:center;font-size:10px;color:#555">Thank You</div>
                        <div style="text-align:right;font-size:11px;font-weight:700;color:#333;margin-top:28px">School Stamp &amp; Sign</div>
                    </div>
                </div>
                <script>window.print();window.close();<\/script>
            </body></html>`);
        win.document.close();
        win.focus();
    };

    render() {
        const { feeReport = [], loading = false, student = {}, getPaymentModes = [], getOrganisationProfile = null } = this.props;

        if (loading) {
            return (
                <div className="text-center py-5 text-muted">
                    <i className="fas fa-spinner fa-spin mr-2"></i> Loading fee report...
                </div>
            );
        }

        // Calculations
        let totalAnnual = 0;
        let totalPaid = 0;
        let totalPending = 0;
        let instalmentsTotal = 0;
        let instalmentsPaid = 0;
        const paidDates = [];

        // Breakdown row construction
        const breakdownRows = feeReport.map(ft => {
            const annual = ft.fee_amount || ft.total_fee || 0;
            const paid = (ft.terms || []).reduce((s, t) => s + (parseInt(t.paid_amount) || 0), 0);
            const pending = Math.max(0, annual - paid);

            totalAnnual += annual;
            totalPaid += paid;
            totalPending += pending;

            (ft.terms || []).forEach(t => {
                instalmentsTotal++;
                const paidAmt = parseInt(t.paid_amount) || 0;
                if (paidAmt > 0) {
                    instalmentsPaid++;
                    if (t.paid_date) {
                        paidDates.push(parseInt(t.paid_date));
                    }
                }
            });

            return {
                name: ft.fee_type_name,
                annual,
                paid,
                pending
            };
        });

        const lastPaidUnix = paidDates.length > 0 ? Math.max(...paidDates) : null;
        const lastPaidText = lastPaidUnix ? ` · last on ${moment.unix(lastPaidUnix).format("DD MMM YYYY")}` : "";

        // Find first due term for the action block
        let firstDueTerm = null;
        let firstDueFeeType = "";
        feeReport.forEach(ft => {
            (ft.terms || []).forEach(t => {
                const amt = parseInt(t.term_amount) || 0;
                const paid = parseInt(t.paid_amount) || 0;
                if (paid < amt && !firstDueTerm) {
                    firstDueTerm = t;
                    firstDueFeeType = ft.fee_type_name;
                }
            });
        });

        // Payment/ledger history list construction
        const paymentList = [];
        feeReport.forEach(ft => {
            (ft.terms || []).filter(t => (parseInt(t.paid_amount) || 0) > 0).forEach(t => {
                const pm = getPaymentModes.find(p => +p.id === +t.payment_mode_id);
                paymentList.push({
                    fee_type: ft.fee_type_name,
                    term_no: t.term_no,
                    is_due: t.is_due_entry == 1,
                    due_from: t.due_from_term_no,
                    amount: parseInt(t.paid_amount) || 0,
                    paid_date: t.paid_date,
                    payment_mode: pm?.payment_mode || "—",
                    receipt_no: t.payment_id || "—",
                });
            });
        });

        // Sort history chronologically
        paymentList.sort((a, b) => parseInt(b.paid_date) - parseInt(a.paid_date));

        // Re-assign IDs after sorting to keep them indexed cleanly
        paymentList.forEach((item, idx) => {
            item.id = idx + 1;
        });

        // Columns configuration for CardLessDataTableWithSearch
        const paymentColumns = [
            {
                dataField: "fee_type",
                text: "DESCRIPTION",
                sort: true,
                classes: "font-weight-bold text-dark",
                formatter: (cell, row) => `${cell} (Q${row.term_no})`
            },
            {
                dataField: "term_no",
                text: "TERM",
                sort: true,
                classes: "text-secondary",
                formatter: (cell) => getTermRangeText(cell)
            },
            {
                dataField: "amount",
                text: "AMOUNT",
                sort: true,
                classes: "font-weight-bold text-dark text-right",
                headerClasses: "text-right",
                formatter: (cell) => rupeeFmt(cell)
            },
            {
                dataField: "paid_date",
                text: "PAID ON",
                sort: true,
                classes: "text-secondary",
                formatter: (cell) => fmtDate(cell)
            },
            {
                dataField: "payment_mode",
                text: "MODE",
                sort: true,
                classes: "text-secondary"
            },
            {
                dataField: "status",
                text: "STATUS",
                sort: true,
                formatter: () => (
                    <span style={{
                        backgroundColor: '#def7ec',
                        color: '#03543f',
                        padding: '4px 10px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: '600',
                        display: 'inline-block'
                    }}>
                        Paid
                    </span>
                )
            },
            {
                dataField: "receipt_no",
                text: "RECEIPT",
                sort: true,
                classes: "text-center",
                headerClasses: "text-center",
                formatter: (cell, row) => (
                    <button
                        onClick={() => this.viewPDF(row)}
                        className="btn btn-sm"
                        style={{ backgroundColor: '#f1f5f9', color: '#475569', fontSize: '11px', fontWeight: '600', padding: '4px 10px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                    >
                        <i className="fa fa-download pr-2" style={{ fontSize: '12px' }}></i>
                        Download
                    </button>
                )
            }
        ];

        // Columns configuration for Breakdown Table
        const breakdownColumns = [
            {
                dataField: "name",
                text: "HEAD",
                sort: false,
                classes: (cell, row) => row.isTotal ? "font-weight-bold text-dark border-top pt-2" : "font-weight-bold text-dark py-2"
            },
            {
                dataField: "annual",
                text: "ANNUAL",
                sort: false,
                classes: (cell, row) => row.isTotal ? "text-right text-dark font-weight-bold border-top pt-2" : "text-right text-secondary py-2",
                headerClasses: "text-right",
                formatter: (cell) => rupeeFmt(cell)
            },
            {
                dataField: "paid",
                text: "PAID",
                sort: false,
                classes: (cell, row) => row.isTotal ? "text-right text-dark font-weight-bold border-top pt-2" : "text-right text-secondary py-2",
                headerClasses: "text-right",
                formatter: (cell) => rupeeFmt(cell)
            },
            {
                dataField: "pending",
                text: "PENDING",
                sort: false,
                classes: (cell, row) => {
                    let base = "text-right font-weight-bold ";
                    if (row.isTotal) base += "text-dark border-top pt-2";
                    else if (cell > 0) base += "text-danger py-2";
                    else base += "text-secondary py-2";
                    return base;
                },
                headerClasses: "text-right",
                formatter: (cell) => cell > 0 ? rupeeFmt(cell) : '—'
            }
        ];

        const breakdownData = [
            ...breakdownRows.map((r, idx) => ({ ...r, id: idx + 1 })),
            {
                id: breakdownRows.length + 1,
                name: "Total",
                annual: totalAnnual,
                paid: totalPaid,
                pending: totalPending,
                isTotal: true
            }
        ];

        return (
            <div style={{ fontFamily: 'Inter, sans-serif', color: '#1e293b' }}>

                {/* 1. Summary Cards */}
                <Row className="mb-4">
                    {[
                        {
                            id: 1,
                            label: "Total fees (2026-27)",
                            value: rupeeFmt(totalAnnual),
                            subtext: `${instalmentsTotal} instalments planned`,
                            color: "#64748b"
                        },
                        {
                            id: 2,
                            label: "Paid",
                            value: rupeeFmt(totalPaid),
                            subtext: `${instalmentsPaid} instalments${lastPaidText}`,
                            color: "#10b981"
                        },
                        {
                            id: 3,
                            label: "Pending",
                            value: rupeeFmt(totalPending),
                            subtext: firstDueTerm ? `${getTermRangeText(firstDueTerm.term_no)} ${firstDueFeeType.toLowerCase()} · due ${moment.unix(parseInt(firstDueTerm.term_date)).format("DD MMM YYYY")}` : "No pending instalments",
                            color: "#ef4444"
                        }
                    ].map((card) => (
                        <Col md={4} key={card.id} className="mb-3 mb-md-0">
                            <Card
                                className="shadow-sm"
                                style={{
                                    border: 'none',
                                    borderTop: `4px solid ${card.color}`,
                                    borderRadius: '12px',
                                    height: '100%'
                                }}
                            >
                                <Card.Body className="p-3">
                                    <div className="d-flex align-items-center mb-1" style={{ gap: '8px', fontSize: '12px', color: '#64748b', fontWeight: '500' }}>
                                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: card.color, display: 'inline-block' }}></span>
                                        {card.label}
                                    </div>
                                    <h4 className="font-weight-bold mb-1" style={{ color: card.id === 2 ? '#10b981' : card.id === 3 ? '#ef4444' : '#0f172a', fontSize: '24px' }}>
                                        {card.value}
                                    </h4>
                                    <div style={{ fontSize: '11px', color: '#64748b' }}>{card.subtext}</div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* 2. Breakdown and Due Action Panel */}
                <Row className="mb-4">
                    {/* Left side: Fee breakdown */}
                    <Col lg={7} className="mb-3 mb-lg-0">
                        <div className="p-3 bg-white border rounded h-100" style={{ borderColor: '#e2e8f0', borderRadius: '12px' }}>
                            <div className="d-flex align-items-center mb-3" style={{ gap: '8px', fontWeight: '600', fontSize: '14px', color: '#0f172a' }}>
                                <i className="fas fa-list-ol text-secondary" style={{ fontSize: '14px' }}></i>
                                Fee breakdown
                            </div>
                            {breakdownData.length > 0 ? (
                                <CardLessDataTableWithSearch
                                    parentData={breakdownData}
                                    particlecolumns={breakdownColumns}
                                    name="fee_breakdown"
                                    searchBar={false}
                                />
                            ) : (
                                <div className="text-center py-4 text-muted">No records found.</div>
                            )}
                        </div>
                    </Col>

                    {/* Right side: Due action */}
                    <Col lg={5}>
                        <div className="p-3 bg-white border rounded h-100" style={{ borderColor: '#e2e8f0', borderRadius: '12px' }}>
                            <div className="d-flex align-items-center mb-3" style={{ gap: '8px', fontWeight: '600', fontSize: '14px', color: '#0f172a' }}>
                                <i className="fas fa-bell text-danger" style={{ fontSize: '14px' }}></i>
                                Due fees - action required
                            </div>

                            {firstDueTerm ? (
                                <div className="p-3" style={{ backgroundColor: '#fff5f5', border: '1px solid #fecaca', borderRadius: '10px' }}>
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <div className="font-weight-bold text-dark" style={{ fontSize: '14px' }}>
                                                {getTermRangeText(firstDueTerm.term_no)} {firstDueFeeType}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#dc2626', marginTop: '2px' }}>
                                                Due {moment.unix(parseInt(firstDueTerm.term_date)).format("DD MMM YYYY")}
                                            </div>
                                        </div>
                                        <h4 className="font-weight-bold text-danger mb-0" style={{ fontSize: '20px' }}>
                                            {rupeeFmt(totalPending)}
                                        </h4>
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '14px' }}>
                                        Auto-SMS scheduled · Actions available below
                                    </div>
                                    <Row>
                                        {
                                            [
                                                {
                                                    id: 1,
                                                    label: "Collect now",
                                                    icon: "fas fa-credit-card",
                                                    type: "primary"
                                                },
                                                {
                                                    id: 2,
                                                    label: "Send reminder",
                                                    icon: "fas fa-paper-plane",
                                                    type: "secondary"
                                                },
                                                {
                                                    id: 3,
                                                    label: "concession",
                                                    icon: "fas fa-edit",
                                                    type: "secondary"
                                                }
                                            ]
                                                .map((item) => (
                                                    <Col md={4} key={item.id}>
                                                        <button
                                                            className={`btn ${item.type === "primary"
                                                                ? "btn-primary"
                                                                : "btn-outline-secondary"
                                                                } btn-sm d-flex align-items-center justify-content-center gap-1 w-100`}
                                                            style={{
                                                                padding: "6px 12px",
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                borderRadius: "6px",
                                                                backgroundColor:
                                                                    item.type === "primary" ? "#2563eb" : "#fff",
                                                                border:
                                                                    item.type === "primary"
                                                                        ? "none"
                                                                        : "1px solid #d1d5db",
                                                                color:
                                                                    item.type === "primary" ? "#fff" : "#374151"
                                                            }}
                                                        >
                                                            <i className={item.icon} style={{ fontSize: '12px' }}></i>&nbsp;&nbsp;
                                                            {item.label}
                                                        </button>
                                                    </Col>
                                                ))}
                                    </Row>
                                </div>
                            ) : (
                                <div className="p-4 text-center text-success" style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '10px' }}>
                                    <i className="fas fa-check-circle fa-2x mb-2 text-success"></i>
                                    <div className="font-weight-bold" style={{ fontSize: '14px' }}>All fees cleared!</div>
                                    <div style={{ fontSize: '11px', color: '#16a34a' }}>No outstanding dues for this student.</div>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>

                {/* 3. Payment history */}
                <div className="p-3 bg-white border rounded" style={{ borderColor: '#e2e8f0', borderRadius: '12px' }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center" style={{ gap: '8px', fontWeight: '600', fontSize: '14px', color: '#0f172a' }}>
                            <i className="fas fa-history text-secondary" style={{ fontSize: '14px' }}></i>
                            Payment history
                        </div>

                        <div className="d-flex justify-content-end align-items-center mt-3 pr-3" style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                            <span className="text-secondary mr-2" style={{ fontWeight: '600', fontSize: '13px' }}>Total Paid:</span>
                            <span className="text-success" style={{ fontSize: '16px' }}>{rupeeFmt(totalPaid)}</span>
                        </div>

                        {paymentList.length > 0 && (
                            <button
                                onClick={() => this.downloadAllPayments(paymentList, totalPaid)}
                                title="Download all payment history"
                                style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "8px 16px", fontSize: 12, fontWeight: 700, color: "#1d4ed8", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 7 }}
                            >
                                <i className="fas fa-download" /> Download All History
                            </button>
                        )}
                    </div>

                    {paymentList.length > 0 ? (
                        <>
                            <CardLessDataTableWithSearch
                                parentData={paymentList}
                                particlecolumns={paymentColumns}
                                name="payment_history"
                                placeholder="Search payment history..."
                            />
                        </>
                    ) : (
                        <div className="text-center py-4 text-muted">No records found.</div>
                    )}
                </div>
            </div>
        );
    }
}

export default StudentFees;